// Modules
import cn from 'classnames';

// Types
import type { TCheckboxProps } from './Checkbox.type';

// Styles
import styles from './styles.module.scss';

// Icons
import { CheckboxIconCheck, CheckboxIconIndeterminate } from './CheckboxIcons';

// Constants
import { CHECKBOX_DEFAULT_PROPS, CHECKBOX_LABEL_POSITION } from './Checkbox.constant';

const Checkbox = (props: TCheckboxProps) => {
  const {
    block,
    checked,
    className,
    disabled,
    iconClassName,
    id,
    indeterminate,
    inputClassName,
    label,
    labelClassName,
    labelPosition = CHECKBOX_DEFAULT_PROPS.labelPosition,
    required,
    size = CHECKBOX_DEFAULT_PROPS.size,
    style,
    ...restProps
  } = props;
  const inputId = id || Math.random().toString(36).substring(7);
  const isLeftLabel = labelPosition === CHECKBOX_LABEL_POSITION.left;

  const checkboxCN = cn(styles.legion_checkbox, styles[size!], className, {
    [styles.block]: block,
    [styles.disabled]: disabled,
    [styles.left_label]: isLeftLabel,
  });
  const inputCN = cn(styles.checkbox_input, inputClassName);
  const iconCN = cn(styles.checkbox_icon, iconClassName);
  const labelCN = cn(styles.checkbox_label, labelClassName);

  return (
    <div className={checkboxCN} style={style}>
      <input
        id={inputId}
        type="checkbox"
        className={inputCN}
        disabled={disabled}
        checked={checked}
        required={required}
        {...restProps}
      />
      <span className={iconCN}>
        {indeterminate ? <CheckboxIconIndeterminate/> : <CheckboxIconCheck/>}
      </span>
      {label && (
        <label htmlFor={inputId} className={labelCN}>
          {label}
        </label>
      )}
    </div>
  );
}

export default Checkbox;
